import { render, staticRenderFns } from "./GameDistributionChartMobile.vue?vue&type=template&id=665a5061&scoped=true"
import script from "./GameDistributionChartMobile.vue?vue&type=script&lang=js"
export * from "./GameDistributionChartMobile.vue?vue&type=script&lang=js"
import style0 from "./GameDistributionChartMobile.vue?vue&type=style&index=0&id=665a5061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a5061",
  null
  
)

export default component.exports